import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './assets/index.css';
import { registerServiceWorker } from './utils/serviceWorkerRegistration';

// Service Worker registrieren (für PWA und Offline-Funktionalität)
registerServiceWorker();

import { getEnv } from "./utils/env";

// Google Client ID aus Environment
const googleClientId = getEnv('VITE_GOOGLE_CLIENT_ID') || '';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
